module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/nb-card-drag.63b1d76da8445c37aa6f.gif";